class Messages {
    getMessage(score){
        if (score === 1) {
            return 'Impressive! You know your stuff. A win like that should be shared with your friends';
        }
        if (score > 1 && score < 10) {
            return 'Not bad, but we know you can do better. Why not have another go?';
        }
        if (score > 9 && score < 21) {
            return 'Well done mate, you are the king of being mediocre.';
        }
        if (score > 20 && score < 30) {
            return 'Hmmm. The less said about that the better. Try again.';
        }
        if (score === 30) {
            return 'Congratulations, literally no one did worse than you.';
        }
    }
}

export default Messages;



// WEBPACK FOOTER //
// ./src/components/elimination-end/messages.js